import { render } from "./ControlMenuButton.vue?vue&type=template&id=58d4106a&ts=true"
import script from "./ControlMenuButton.vue?vue&type=script&lang=ts"
export * from "./ControlMenuButton.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__